import React, { useState, useEffect } from 'react';
import './AnnouncementsNew.css';
import AnnouncementCard from './components/AnnouncementCard';
import { AnnouncementService } from '../../../service/manage/announcement/announcement.service';
import { AnnouncementTopicService } from '../../../service/settings/manage/announcement_topic.service';
import AnnouncementsBoy from '../../../assets/images/Announcementsboy.png';
import { history } from '../../../helper/history';
import { HiInbox } from 'react-icons/hi2';

const AnnouncementsNew = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);
    const [topicsMap, setTopicsMap] = useState({});
    const [viewAll, setViewAll] = useState(false);

    useEffect(() => {
        loadTopics();
        loadAnnouncements();
    }, []);

    const loadTopics = async () => {
        try {
            const res = await AnnouncementTopicService.getAllAnnouncementTopics();
            if (res.success) {
                // create a map of id -> name for quick lookup
                const map = (res.data || []).reduce((acc, t) => {
                    acc[t.announcement_topic_id] = t.name;
                    return acc;
                }, {});
                setTopicsMap(map);
            }
        } catch (err) {
            console.error('Error loading topics:', err);
        }
    };

    const loadAnnouncements = async () => {
        try {
            const response = await AnnouncementService.getAllAnnouncementsCGC();
            if (response.success) {
                setAnnouncements(response.data.announcements || []);
            }
        } catch (error) {
            console.error('Error loading announcements:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleBackToHome = () => {
        history.push('/manage-dashboard');
    };

    const handleViewAllUpdates = () => {
        // Toggle View All mode
        setViewAll(prev => !prev);
    };

    const handleAnnouncementClick = (announcement) => {
        console.log('Announcement clicked:', announcement);
        // Optional: open modal or navigate to detail page
    };

    return (
        <div className={`announcements-new-page ${viewAll ? 'view-all-active' : ''}`}>
            <div className="announcements-header">
                <div className="announcements-header-left">
                    <h1 className="announcements-title">Announcements</h1>
                    <p className="announcements-subtitle">& Updates</p>
                </div>
                <div className="announcements-header-right">
                    <button className="view-all-updates-btn view-all-btn" onClick={handleViewAllUpdates} aria-pressed={viewAll}>
                        {viewAll ? 'Show Less' : 'View All'}
                    </button>
                    <button className="view-all-updates-btn back-to-home-btn" onClick={handleBackToHome}>
                        Back
                    </button>
                </div>
            </div>

            <div className="announcements-content">
                <div className="announcements-left-section">
                    <div className="announcements-mascot">
                        <img
                            src={AnnouncementsBoy}
                            alt="Announcements Mascot"
                            className="mascot-image"
                        />
                    </div>
                </div>

                <div className="announcements-right-section">
                    {loading ? (
                        <div className="announcements-loading">
                            <div className="loading-spinner"></div>
                            <p>Loading announcements...</p>
                        </div>
                    ) : announcements.length === 0 ? (
                        <div className="announcements-empty">
                            <div className="empty-icon">
                                <HiInbox />
                            </div>
                            <h2 className="empty-title">No Recent Updates</h2>
                            <p className="empty-description">
                                There are no new announcements at the moment. We'll notify you the moment something important lands here.
                            </p>
                        </div>
                    ) : (
                        <div className="announcements-list">
                            {announcements.map((announcement) => (
                                <AnnouncementCard
                                    key={announcement.id}
                                    announcement={announcement}
                                    topicName={topicsMap[announcement.announcement_topic_id] || announcement.topic || announcement.announcement_topic || ''}
                                    onClick={() => handleAnnouncementClick(announcement)}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AnnouncementsNew;

